import React, { Component } from "react";
import { Api } from "../../app-controller.js";
import { format } from "date-fns";

class ModalSolicitudPrecertificado extends Component {
  render() {
    return (
      <>
        <div>
          <div id="SolicitudPrecertificado">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_pre.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_pre.tramite}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_pre.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.props.state.solicitud_pre.fecha_solicitud !== null
                          ? format(
                              new Date(
                                this.props.state.solicitud_pre.fecha_solicitud
                              ),
                              "dd/MM/yyyy"
                            )
                          : this.props.state.solicitud_pre.fecha_solicitud}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr></hr>
            <div className="row">
              <div
                className={
                  this.props.state.solicitud_pre.exportador === "0" &&
                  this.props.state.solicitud_pre.establecimiento_exporta_id ==
                    null
                    ? "row form-group col-lg-12"
                    : "hide"
                }
              >
                <div className=" widget widget-stats bg-gradient-yellow m-b-1 col-lg-12">
                  <div className="stats-content">
                    <div className="stats-desc" style={{ color: "black" }}>
                      <strong>¡Cuidado!</strong> El establecimiento de la
                      solicitud no cuenta con la actividad de exportador y no
                      relacionó un establecimiento exportador.
                    </div>
                  </div>
                </div>
              </div>
              <fieldset className="col-md-12">
                <legend>Precertificado</legend>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Establecimiento</label>
                    <div className="form-control">
                      {this.props.state.solicitud_pre.establecimiento}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Tipo producto</label>
                    <div className="form-control">
                      {this.props.state.solicitud_pre.tipo_producto}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Nombre consignatario</label>
                    <div className="form-control">
                      {this.props.state.solicitud_pre.consignatario}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>País destino</label>
                    <div className="form-control">
                      {this.props.state.solicitud_pre.pais_destino}
                    </div>
                  </div>
                </div>

                <div
                  className={
                    this.props.state.solicitud_pre.exportador === 0 &&
                    this.props.state.solicitud_pre.establecimiento_exporta_id !=
                      null
                      ? "row"
                      : "hide"
                  }
                >
                  <div className="form-group col-md-6">
                    <label>Establecimiento exportador</label>
                    <div className="form-control">
                      {this.props.state.solicitud_pre.establecimiento_exporta}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Guid establecimiento exportador</label>
                    <div className="form-control">
                      {this.props.state.solicitud_pre.guid_exporta}
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr></hr>{" "}
              <div
                className={
                  this.props.state.solicitud_pre.lista_productos_registrados
                    .length > 0
                    ? "row col-md-12"
                    : "row hide"
                }
              >
                <fieldset className="col-md-12">
                  <legend>Productos registrados</legend>
                  <div className="col-md-12">
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>No. registro</th>
                          <th>Nombre comercial</th>
                          <th>Pais origen</th>
                          <th>Cantidad</th>
                          <th>Tipo de envase/empaque</th>
                          <th>Presentación cantidad</th>
                          <th>Unidad de medida</th>
                          {
                            <th
                              className={
                                this.props.state.tipo_precertificado_id !== 3
                                  ? ""
                                  : "hide"
                              }
                            >
                              Tipo certificado
                            </th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.solicitud_pre
                          .lista_productos_registrados.length > 0
                          ? this.props.state.solicitud_pre.lista_productos_registrados.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.no_registro}</td>
                                  <td>{reg.nombre_comercial}</td>
                                  <td>{reg.pais_origen_pro}</td>
                                  <td>{reg.cantidad}</td>
                                  <td>{reg.tipo_envase}</td>
                                  <td>{reg.cantidad_presentacion}</td>
                                  <td>{reg.unidad_medida_presentacion}</td>
                                  {
                                    <td
                                      className={
                                        reg.tipo_precertificado_id !== 3
                                          ? ""
                                          : "hide"
                                      }
                                    >
                                      {reg.tipo_precertificado_name}
                                    </td>
                                  }
                                </tr>
                              )
                            )
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </div>
              <div
                className={
                  this.props.state.solicitud_pre.lista_productos_no_registrados
                    .length > 0
                    ? "row col-md-12"
                    : "row hide"
                }
              >
                <fieldset className="col-md-12">
                  <legend>Productos no registrados</legend>
                  <div className="col-md-12">
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Nombre comercial</th>
                          <th>Cantidad total</th>
                          <th>Fabricante</th>
                          <th>Pais origen</th>
                          <th>Tipo de envase/empaque</th>
                          <th>Presentación cantidad</th>
                          <th>Unidad de medida</th>
                          {
                            <th
                              className={
                                this.props.state.tipo_precertificado_id !== 3
                                  ? ""
                                  : "hide"
                              }
                            >
                              Tipo certificado
                            </th>
                          }
                        </tr>
                      </thead>
                      {this.props.state.solicitud_pre
                        .lista_productos_no_registrados.length > 0
                        ? this.props.state.solicitud_pre.lista_productos_no_registrados.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.nombre_comercial}</td>
                                <td>{reg.cantidad}</td>
                                <td>{reg.fabricante_nombre}</td>
                                <td>{reg.pais_origen_pro}</td>
                                <td>{reg.tipo_envase}</td>
                                <td>{reg.cantidad_presentacion}</td>
                                <td>{reg.unidad_medida_presentacion}</td>
                                {<td
                                    className={
                                      reg.tipo_precertificado_id !== 3 
                                        ? ""
                                        : "hide"
                                    }
                                  >
                                    {reg.tipo_precertificado_name}
                                  </td> }
                              </tr>
                            )
                          )
                        : ""}
                    </table>
                  </div>
                </fieldset>
              </div>
              <div
                className={
                  this.props.state.solicitud_pre.documentos.length
                    ? "col-md-12"
                    : "hide"
                }
              >
                <hr></hr>
                <fieldset className="col-md-12">
                  <legend>Documentación</legend>
                  <div className="table-responsive">
                    <button
                      className="btn btn-primary pull-right"
                      id="descarga_docs_pce"
                      onClick={this.props.component.handleDownloadZipPRE}
                    >
                      Descargar selección
                    </button>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th width="50">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                onChange={(e) =>
                                  this.props.component.allDocsSolPre(e)
                                }
                                type="checkbox"
                                value={this.props.state.allDocsPre || false}
                                name="allc_e"
                                checked={this.props.state.allDocsPre || false}
                                id="allc_e"
                              />
                              <label htmlFor="allc_e">Todos</label>
                            </div>
                          </th>
                          <th className="text-center">Vista previa</th>
                          <th className="text-center">Documento</th>
                          <th className="text-center">Fecha carga</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">
                            Fecha aprobación DRICYP
                          </th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody
                        className={this.props.state.working ? "hide" : "show"}
                      >
                        {this.props.state.solicitud_pre.documentos.map(
                          (sol,) => (
                            <tr key={sol.id}>
                              <td className="text-center">
                                <div className="checkbox checkbox-inline checkbox-css">
                                  <input
                                    type="checkbox"
                                    className="checkbox_pre"
                                    id={sol.id}
                                    onChange={(e) => {
                                      this.props.component.handleSolicitudChecksPre(
                                        e
                                      );
                                    }}
                                    name={sol.id}
                                    value={
                                      this.props.state.solicitudDocsCheckPre[
                                        sol.id
                                      ] || false
                                    }
                                    checked={
                                      this.props.state.solicitudDocsCheckPre[
                                        sol.id
                                      ] || false
                                    }
                                  />
                                  <label htmlFor={sol.id}></label>
                                </div>
                              </td>
                              <td className="text-center">
                                <img
                                  alt="Vista previa"
                                  className="rounded btn vista-previa"
                                  data-id={sol.id}
                                  onClick={this.props.component.handlePreviaPre}
                                  width="60"
                                  src={
                                    Api.url +
                                    `app/vistapreviaPRE/?id=${sol.id}&thumb=1`
                                  }
                                />
                              </td>
                              <td className="text-center">{sol.documento}</td>
                              <td align="center">
                                {sol.fecha_solicitud !== null
                                  ? format(
                                      new Date(sol.fecha_solicitud),
                                      "dd/MM/yyyy"
                                    )
                                  : ""}
                              </td>

                              <td className="text-center pce-doc-status">
                                {sol.estatus_documento}
                              </td>

                              <td align="center">
                                {sol.fecha_aprobacion !== null
                                  ? format(
                                      new Date(sol.fecha_aprobacion),
                                      "dd/MM/yyyy"
                                    )
                                  : ""}
                              </td>

                              <td className="text-center">
                                <div className="btn-group">
                                  <a
                                    href={
                                      Api.url +
                                      `app/vistapreviaPRE/?id=${sol.id}&download=1`
                                    }
                                    className="btn btn-primary"
                                  >
                                    <i className="fas fa-file-download"></i>
                                  </a>
                                  <button
                                    className={ 
                                      sol.estatus_documento_id !== "1"||
                                      sol.estatus_tramite_id !== "9"  
                                        ? "blockea btn btn-danger "
                                        : "btn btn-danger documento-pre-rechazar"
                                    }                                    
                                    data-subproducto_id={
                                      sol.rel_subproducto_producto_id
                                    }
                                    data-solicitud_estatus={
                                      sol.estatus_documento_id
                                    }
                                    id={sol.id}
                                    onClick={
                                      this.props.component
                                        .handlesolicitudDocumentoStatusPre
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    name="Rechazar"
                                    disabled={
                                      sol.estatus_documento_id !== "1"||
                                      sol.estatus_tramite_id !== "9" 
                                        ? true
                                        : false
                                    }
                                    data-name="Rechazar"
                                  >
                                    <i
                                      className="fas fa-ban documento-pre-rechazar"
                                      data-subproducto_id={
                                        sol.rel_subproducto_producto_id
                                      }
                                      data-solicitud_estatus={
                                        sol.estatus_documento_id
                                      }
                                      id={sol.id}
                                      onClick={
                                        this.props.component
                                          .handlesolicitudDocumentoStatusPre
                                      }
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      data-name="Rechazar"
                                      disabled={
                                        sol.estatus_documento_id !== "1"||
                                        sol.estatus_tramite_id !== "9" 
                                          ? true
                                          : false
                                      }
                                    ></i>
                                    Rechazar
                                  </button>
                                  <button
                                    className={
                                      sol.estatus_documento_id !== "1"||
                                      sol.estatus_tramite_id !== "9" 
                                        ? "blockea btn btn-success "
                                        : "btn btn-success documento-pre-aceptar"
                                    }
                                    data-subproducto_id={
                                      sol.rel_subproducto_producto_id
                                    }
                                    data-solicitud_estatus={
                                      sol.estatus_documento_id
                                    }
                                    id={sol.id}
                                    onClick={
                                      this.props.component
                                        .handlesolicitudDocumentoStatus
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Aprobar"
                                    disabled={
                                      sol.estatus_documento_id !== "1"||
                                      sol.estatus_tramite_id !== "9" 
                                        ? true
                                        : false
                                    }
                                  >
                                    <i
                                      className="fas fa-check  documento-pre-aceptar"
                                      onClick={
                                        this.props.component
                                          .handlesolicitudDocumentoStatus
                                      }
                                      data-subproducto_id={
                                        sol.rel_subproducto_producto_id
                                      }
                                      data-solicitud_estatus={
                                        sol.estatus_documento_id
                                      }
                                      id={sol.id}
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      data-name="Aprobar"
                                      disabled={
                                        sol.estatus_documento_id !== "1" ||
                                        sol.estatus_tramite_id !== "9" 
                                          ? true
                                          : false
                                      }
                                    ></i>
                                    Aprobar
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
                <hr></hr>
              </div>
              <div className="col-md-12">
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.props.component.handlePrecertificadoStatus}
                    value="4"
                    id="rechazar_pre"
                    className="btn btn-danger"
                    //disabled={this.props.state.certificado.aprobado==="5" || this.props.state.certificado.aprobado==="4"? true: false}
                  >
                    Rechazar
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
                  {/*    <button id="regresar_mv" className="btn btn-white ">
                            Regresar
                          </button> */}
                  <button
                    onClick={this.props.component.handlePrecertificadoStatus}
                    value="5"
                    id="aprobar_pre"
                    className="btn btn-success"
                    //disabled={this.props.state.certificado.aprobado==="5" || this.props.state.certificado.aprobado==="4"? true: false}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
              <div className={this.props.state.previa ? "previa" : "hide"}>
                <iframe
                  title="Vista previa"
                  className="rounded"
                  src={this.props.state.previa_url}
                ></iframe>
                <center>
                  <div className="btn-group">
                    <button
                      onClick={() => {
                        this.props.component.handlePreviaClosePre();
                      }}
                      className="btn btn-danger"
                    >
                      Regresar
                    </button>
                    <a
                      className="btn btn-primary"
                      href={this.props.state.previa_url + "&download=1"}
                      download="download"
                    >
                      Descargar
                    </a>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ModalSolicitudPrecertificado;
